import Vue from "vue";
import Vuex from "vuex";

// Modules
import browserModule from "./modules/browser/module";

// Init
Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    browser: browserModule,
  },
});

window.addEventListener("message", (e) => {
  console.log(e);

  if (typeof e.data === "string") {
    if (e.data.includes("parentHeight")) {
      const height = e.data.split("/")[1];
      document.querySelector(".absolute-wrapper").style.height = `${height}px`;
    }
  }
  if (Array.isArray(e.data)) {
    const favs = [];
    e.data.forEach((id) => {
      const flat = store.getters.GET_FLATS.find(
        ({ investments_number }) => investments_number === id
      );
      favs.push(flat);
    });
    store.commit("SET_FAVOURITES", favs);
  }
  if (e.data && typeof e.data === "string") {
    if (e.data.includes("http")) {
      sessionStorage.setItem("source", e.data);
    }
  }
});

export default store;
